export const APP_CONFIG = {
    appName: 'Gallagher Bedrocc',
    frontend: 'https://bedro.cc',
    apiHash: 'https://bedro.cc/api/1.0',
    api: '/api/2.0',
    trustModel: false,
    commitSHA: '8931abe',
    authHeaders: {
        xServiceProvider: 'bedrocc-frontend',
        'tenant-id': 'f83ba56e-1936-4d91-b6d0-88ef7c744d36',
        'consumer-id': '20808877-ac33-4a2e-bab7-5b9af7473020',
    },
    provider: 'bedrocc-frontend',
    multilingual: true,
    showNotifications: true,
    showSearch: true,
    demoMode: true,
    chatEnabled: true,
    contactEnabled: true,
    readabilityEnabled: true,
    isDarkModeEnabled: true,
    gtm: 'GTM-PTT2QSC',
    copyright: '<small>&copy; ' + new Date().getFullYear() +
        ' Gallagher | All Rights Reserved.' + '<br />Powered by Core.' + '</small>',
    imagery: {
        logo: 'https://storage.googleapis.com/archipelago-assets/bedrocc/bedrocc-logo.svg',
        logoTransparent: 'https://storage.googleapis.com/archipelago-assets/bedrocc/bedrocc-logo.svg',
        logoInverted: 'https://storage.googleapis.com/archipelago-assets/bedrocc/bedrocc-logo-reverse.svg',
    },
    navigation: {
        navType: 'top',
        headerStyle: 'solid',
        categoryNav: true
    },
    pwa: {
        enabled: false,
        notifications: false,
    },
   enableSSR: false,
};

